let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("c08ou")]).then(() => parcelRequire('99rcJ'));